import React, { useEffect, useState } from 'react';
import {BrowserRouter, Routes as Router, Route, useLocation} from 'react-router-dom';
import HomePage from "./components/HomePage";
import HomePageOLD26 from './components/HomePageOLD26';

import { RegistraAcessos } from './components/funcionalidades/bancoGet.js';


function Tracker() {
    const location = useLocation();

    // Mapeamento fixo: rota -> nome amigavel
    const nomesTelas = {
        "/Encontrar Revendedora": "Encontrar Revendedora",
    };

    useEffect(() => {
        RegistraAcessos({nome_rota: "Encontrar Revendedora", nome_tela: "Encontrar Revendedora"})
    }, [location]);

    return null; // Nao renderiza nada
}

function Routes(){

    return(
        <BrowserRouter>
            <Tracker />
            <Router>
                <Route path="/" element={<HomePage />}/>
                <Route path="/OLD26" element={<HomePageOLD26 />}/>
            </Router>
        </BrowserRouter>
    );
 };
export default Routes;
